export class Select {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.width = 200
    this.height = 40
    this.top = 20
    this.left = 20
    this.innerElement = "cxSelect"
    this.value = ""
    this.linkValue = "https://www.chaoxing.com/"
    this.selectOptions = [
      {
        label: "选项1",
        value: "https://www.chaoxing.com/"
      },
      {
        label: "选项2",
        value: "http://www.baidu.com"
      },
      {
        label: "选项3",
        value: ""
      },
      {
        label: "选项4",
        value: ""
      },
      {
        label: "选项5",
        value: ""
      }
    ]
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderTopRightRadius = 0
    this.borderTopLeftRadius = 0
    this.liBorderTypeFlag = 2
    this.liBorderRadius = 0
    this.liBorderBottomLeftRadius = 0
    this.liBorderBottomRightRadius = 0
    this.liBorderTopRightRadius = 0
    this.liBorderTopLeftRadius = 0
    this.selectFontFamily = "sans-serif"
    this.selectFontSize = 14
    this.selectFontWeight = "400"
    this.selectFontColor = "rgba(255,255,255,1)"
    this.selectBgColor = "rgba(0, 0, 0, 0.8)"
    this.selectBgIsThemeColor = false
    this.placeHolderFontFamily = "sans-serif"
    this.placeHolderFontSize = 14
    this.placeHolderFontWeight = "400"
    this.placeHolderFontColor = "rgba(255,255,255,1)"
    this.selectBorderColor = "#3D82F2"
    this.selectBorderWidth = [0, 0, 0, 0] //下拉框边框宽度
    this.selectBorderStyle = "solid" // solid, dashed, dotted 下拉框边框风格
    this.selectBorderIsThemeColor = false // 下拉框边框颜色
    this.liIsSameSize = true //下拉列表和下拉框同尺寸
    this.liBorderWidth = [1, 1, 1, 1] //下拉列表项边框宽度
    this.liBorderColor = "#3D82F2" //下拉列表项边框宽度
    this.liBorderStyle = "solid" // solid, dashed, dotted 下拉列表项边框风格
    this.liBorderIsThemeColor = false // 下拉列表项边框颜色
    this.liHeight = 40 // 下拉列表项高度
    this.liWidth = 200 // 下拉列表项高度
    this.liFontFamily = "sans-serif"
    this.liFontSize = 14
    this.liFontWeight = "400"
    this.liFontColor = "rgba(255,255,255,1)"
    this.primaryLiBg = "rgba(0,0,0,0.8)" // 下拉列表项背景色
    this.selectLiBg = "rgba(240, 243, 250, 1)" // 选中的下拉列表项背景色
    this.selectLiColor = "rgba(255,255,255,1)" // 选中的下拉列表项背景色
    this.boxShadowColor = ["rgba(61, 130, 242, 0.5)"] // 下拉列表的阴影
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.showPlaceHolderText = true //是否显示占位符文字
    this.placeholderText = "请选择" //占位符文字
    this.placeHolderFontFamily = "sans-serif"
    this.placeHolderFontSize = 14
    this.placeHolderFontWeight = "400"
    this.placeHolderFontColor = "rgba(255,255,255,1)"
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.open = true
    this.openBlankPage = true
    this.hoverLiBg = "rgba(255, 255, 255, 1)"
    this.hoverLiColor = "rgba(0, 0, 0, 0.8)"
    this.liSltTextIsThemeColor = true //li选中字体主题色
    this.liHovTextIsThemeColor = true //li悬浮字体主题色
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
